import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Header.css';
import logo from '../../assets/icons/logo.png';

function Header(): React.ReactElement {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [navVisible, setNavVisible] = useState<boolean>(false);
  const { isAuthenticated, user, signOut } = useAuth();

  React.useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => requestAnimationFrame(() => setNavVisible(true)));
    } else {
      setNavVisible(false);
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const closeMenu = () => {
    setNavVisible(false);
    setTimeout(() => setMenuOpen(false), 300);
  };

  const mobileMenuPortal = menuOpen ? createPortal(
    <div className="nav-mobile-portal">
      <div
        className="nav-overlay"
        aria-hidden="true"
        onClick={closeMenu}
      />
      <nav className={`nav nav-mobile ${navVisible ? 'nav-open' : ''}`}>
        <button
          className="nav-close"
          aria-label="Close menu"
          onClick={closeMenu}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
        <Link to="/" onClick={closeMenu}>Home</Link>
        <Link to="/#about" onClick={closeMenu}>About</Link>
        <Link to="/#collections" onClick={closeMenu}>Collections</Link>
        <Link to="/#creations" onClick={closeMenu}>Creations</Link>
        <Link to="/#gallery" onClick={closeMenu}>Gallery</Link>
        <Link to="/#showcase" onClick={closeMenu}>Showcase</Link>
        <Link to="/#contact" onClick={closeMenu}>Contact</Link>
        {isAuthenticated && (
          <button type="button" className="nav-signout" onClick={() => { signOut(); closeMenu(); }}>
            Sign out
          </button>
        )}
      </nav>
    </div>,
    document.body
  ) : null;

  return (
    <>
      <div className="top-banner">
        <span>Exclusive discount for first-time customers — Use code WELCOME10</span>
      </div>
      {mobileMenuPortal}
      <header className="header">
        <div className="header-inner">
          <Link to="/" className="logo">
            <div className="logo-img-wrapper">
              <img src={logo} alt="Trupz Looplet" className="logo-img" />
            </div>
          </Link>
          <nav className="nav nav-desktop">
            <Link to="/" onClick={closeMenu}>Home</Link>
            <Link to="/#about" onClick={closeMenu}>About</Link>
            <Link to="/#collections" onClick={closeMenu}>Collections</Link>
            <Link to="/#creations" onClick={closeMenu}>Creations</Link>
            <Link to="/#gallery" onClick={closeMenu}>Gallery</Link>
            <Link to="/#showcase" onClick={closeMenu}>Showcase</Link>
            <Link to="/#contact" onClick={closeMenu}>Contact</Link>
            {isAuthenticated && (
              <button type="button" className="nav-signout" onClick={() => { signOut(); closeMenu(); }}>
                Sign out
              </button>
            )}
          </nav>
          <div className="header-actions">
            <button className="icon-btn" aria-label="Search">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
              </svg>
            </button>
            {isAuthenticated ? (
              <div className="header-account">
                <span className="header-user-name">{user?.name || user?.email}</span>
                <button
                  type="button"
                  className="icon-btn header-signout"
                  onClick={() => { signOut(); setMenuOpen(false); }}
                  aria-label="Sign out"
                >
                  Sign out
                </button>
              </div>
            ) : (
              <Link to="/signin" className="icon-btn" aria-label="Account">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
              </Link>
            )}
            <button className="icon-btn" aria-label="Cart">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
              </svg>
            </button>
            <button 
              className="menu-toggle" 
              aria-label="Toggle menu"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
